<ng-container>
	<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
		<div fxLayout="row wrap" fxLayoutAlign="space-around" fxLayoutGap="0px grid" fxLayoutGap.lt-xl="12px grid">
			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-7Tt" translate>身長</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-5Ot" [(ngModel)]="height" matInput max="999" min="0" name="height" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="user-t-2Aq">cm</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-5Xa" translate>ゴルフ暦</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-6Ou" [(ngModel)]="experience" matInput max="999" min="0" name="experience" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="user-t-5Wq" translate>年</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-8Hb" translate>平均スコア</span></mat-label>
				<input data-idtest="user-i-4Lx" [(ngModel)]="score" matInput max="999" min="0" name="score" placeholder="" step="1" style="text-align: right;" type="number">
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-6Sj" translate>ドライバーの距離</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-7Fq" [(ngModel)]="driver" matInput max="999" min="0" name="driver" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="user-t-7Ng" translate>Yard</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-9Us" translate>7番アイアンの距離</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-1Pr" [(ngModel)]="seveniron" matInput max="999" min="0" name="seveniron" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="user-t-1Nw" translate>Yard</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-4Lo" translate>年間ラウンド回数</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-2Rd" [(ngModel)]="rounds" fxFlex="70" matInput max="999" min="0" name="rounds" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="user-t-3Zf" fxFlex translate>回/年</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-2Od" translate>月間練習回数</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-2Yd" [(ngModel)]="practice" fxFlex="70" matInput max="999" min="0" name="practice" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="user-t-3Hc" fxFlex translate>回/月</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="user-t-3Rd" translate>オフィシャルハンディ</span></mat-label>
				<div fxLayout="row">
					<input data-idtest="user-i-0Fq" [(ngModel)]="handicap" matInput max="99" min="0" name="handicap" placeholder="" step="1" style="text-align: right;" type="number">
				</div>
			</mat-form-field>

		</div>
<!--
		<div fxLayout="row" fxFlex="100" fxLayoutAlign.lt-sm="center center" fxLayoutAlign="column" style="margin-top: 16px; color: #ffffff;background: #1d1d1d;">
			<div data-idtest="user-t-3Bh" class="card-title" style="padding:12px 0 12px 16px;font-size: 14px;letter-spacing: 0.2em;" translate>所属先スタジオ設定</div>
		</div>
		<div fxLayout="row wrap" fxFill fxLayoutAlign="space-evenly" class="card-background">
			<div fxLayout="column" fxLayoutAlign="center" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" style="margin:20px;background: #585858;box-shadow: 1px 4px 2px #20202040;">
				<div fxLayout="row wrap" fxLayoutAlign="center" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" style="background: #585858;">
					<mat-card style="margin:8px;" fxLayoutGap="8px">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0;"><span translate>スタジオ選択</span></mat-card-title>
							<span data-idtest="user-t-8Og" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">

								<mat-form-field>
									<mat-label><span data-idtest="user-t-3Yn" translate>アカウント所属</span></mat-label>
									<mat-select #studio_select="ngModel" [(ngModel)]="parent" name="studio_select">
										<mat-option *ngFor="let studio of studios" [value]="studio.value">
											{{studio.name}}
										</mat-option>
									</mat-select>
								</mat-form-field>

							</div>
						</mat-card-content>
					</mat-card>
				</div>
				<div style="margin:8px;text-align: center;" fxLayoutGap="8px">

				</div>
			</div>

		</div>
		<div class="borders" style="background: rgb(25, 25, 25);">
			<div class="slanting">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none" style="height: 30px;width: 100%;background: rgb(25, 25, 25);">
					<defs>
						<linearGradient id="g1" x1="0%" y1="0%" x2="0%" y2="100%">
							<stop offset="0" stop-color="#383838"/>
							<stop offset="1" stop-color="#282828"/>
						</linearGradient>
					</defs>
					<polygon points="0,0 50,100 100,0" fill="url(#g1)"></polygon>
				</svg>
			</div>
		</div>
		<div fxLayout="row" fxFlex="100" fxLayoutAlign="column" style="color: #ffffff;background: #191919;">
			<div class="left-half"></div>
			<div class="right-half"></div>
			<div data-idtest="user-t-6Ii" class="card-title" style="padding:12px 0px 12px 16px;font-size: 14px;letter-spacing: 0.2em;" translate>所属先スタジオ</div>
		</div>
-->
		<div fxLayout="row" fxLayoutAlign="center">
			<button (click)="onAccept()" [disabled]="form.invalid || isProgress" style="margin:20px;background-color:#99774a;width: 200px;" mat-raised-button id="mat-update-button">
				<div fxLayout="row" fxLayoutAlign="space-between center">
					<mat-icon fxFlex="10">done_outline</mat-icon>
					<div data-idtest="user-t-5Bt" fxFlex="80" translate>更新</div>
					<div fxFlex="10"></div>
				</div>
			</button>
		</div>
	</form>
</ng-container>
